(() => {
  const TOAST_MS = 2000;
  const REDUCED_MOTION_MQ = '(prefers-reduced-motion: reduce)';

  class HiraRatingLink extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.handleClick = this.handleClick.bind(this);
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    // A <button> rather than an <a href="#id">: a link to a missing target still
    // rewrites the URL hash, which is not the silent no-op the block requires.
    handleClick() {
      const target = this.dataset.target;
      const anchor = target ? document.getElementById(target) : null;
      if (!anchor) return;

      const behavior = window.matchMedia(REDUCED_MOTION_MQ).matches ? 'auto' : 'smooth';
      anchor.scrollIntoView({ behavior, block: 'start' });
    }
  }

  class HiraShare extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.toast = this.querySelector('[role="status"]');
      this.toastTimer = null;
      this.canShare = typeof navigator.share === 'function';
      this.canCopy = typeof navigator.clipboard?.writeText === 'function';

      // Neither capability — leave the button `hidden` so it occupies no space,
      // which is what the design asks for when sharing is unavailable.
      if (!this.button || (!this.canShare && !this.canCopy)) return;

      this.handleClick = this.handleClick.bind(this);
      this.button.hidden = false;
      this.button.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      clearTimeout(this.toastTimer);
      this.toastTimer = null;
      this.button?.removeEventListener('click', this.handleClick);
    }

    handleClick() {
      const { shareTitle, shareUrl } = this.dataset;

      if (this.canShare) {
        // A cancelled share sheet rejects with AbortError — not a failure, so it
        // produces no toast and no console noise.
        navigator.share({ title: shareTitle, url: shareUrl }).catch(() => {});
        return;
      }

      navigator.clipboard
        .writeText(shareUrl)
        .then(() => this.showToast())
        .catch(() => {});
    }

    showToast() {
      if (!this.toast) return;

      this.toast.textContent = this.dataset.copiedMessage ?? '';
      this.toast.classList.add('is-visible');

      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast.classList.remove('is-visible');
        this.toast.textContent = '';
        this.toastTimer = null;
      }, TOAST_MS);
    }
  }

  if (!customElements.get('hira-rating-link')) {
    customElements.define('hira-rating-link', HiraRatingLink);
  }

  if (!customElements.get('hira-share')) {
    customElements.define('hira-share', HiraShare);
  }
})();
